<BasePersona :target-personas="target" >
  <slot></slot>
</BasePersona>
